<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Country {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View Country - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Country - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{inputCreatedBy || "System" }} | {{inputCreatedAt | dateFilter}} 
                <br>
                <b><label>Updated By:</label></b>
                {{inputUpdatedBy || "System" }} | {{inputUpdatedAt | dateFilter}} 
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <div v-if="customFormMode == 1" v-show="showDetails">
                <base-input alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                <base-input label="Currency" required>
                    <div class="form-group row">
                        <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="currencyName" disabled>
                        </div>
                        <div class="col-sm-6">
                            <autocomplete
                                ref="autocomplete"
                                placeholder="Search Currency"
                                :source="currencyEndpoint"
                                input-class="form-control"
                                results-property="data"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getCurrency">
                            </autocomplete>
                        </div>
                    </div>
                </base-input>
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="inputRemark"/>
                </base-input>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="mallgroup" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                        <base-input label="Currency" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="currencyName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Currency"
                                        :source="currencyEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getCurrency">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark"/>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="mallgroup" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Add</button>
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div> 
                <div v-else style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div> 
            </div>
        </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'
import DynamicForm from '../DynamicForm.vue'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import moment from 'moment'
var component_x;  
export default {
    components: {
        Autocomplete, DynamicForm
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function() {

        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Country?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
        
        if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                this.userDefinedFields = accSystemModule.customized_fields;
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }
                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }

        if(this.serverType == 'branch'){
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        } else {
            if(this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].disabled = true;
                }
            }
        } 
        component_x = this
        if( component_x.profileId > 0){
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'countries/' + component_x.profileId, null)    
            if(data == undefined){
                component_x.$router.go()
            } else {
                if(data["error"] == undefined){
                    component_x.inputCode = data["code"]
                    component_x.inputName = data["name"]
                    component_x.inputRemark = data["remark"]
                    component_x.inputCurrency = data["currency_id"]
                    component_x.currencyName = data["currency_name"]
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                } 
            } 
        } 
        this.dynamicFormKey++;
    },
    data: function(){
        return {
            mallgroup: null,
            inputCode: '',
            inputName: '',
            inputRemark: '',
            inputCurrency: '',
            currencyName: '',
            errors: [],
            showDetails: true,
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',

            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            userDefinedFields: [],
            supplier: {},
            formErrors: [],
            defaultMallgroupDetails:{},
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
        updateSettings(newFormSettings, settingsGrouping, errors){
            var formSettingsCopy = this.mallgroup
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if(this.customFormMode == 3) {
                this.errors = errors
            }

            this.mallgroup = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        openDetails() {
            this.showDetails = true
        },
        openHistory() {
            this.showDetails = false
        },
        validateForm(){
            this.errors = [];
            // this.errors.push(ValidateField.required('Code', this.inputCode));
            this.errors.push(ValidateField.required('Name', this.inputName));
            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        currencyEndpoint (input) {
            return this.endPoint + '/currencies?name=' + input;
        },
        getCurrency (group) {
            this.currencyName = group.display;
            this.inputCurrency = group.value;
        },
        formattedDisplay (result) {
          return result.name + ' [' + result.code + ']';
        },
        create: async function() {
            if(!this.validateForm()) {
                var countryPayload = {
                    country: {
                        name: this.inputName.trim(),
                        code: this.inputCode.trim(),
                        currency_id: this.inputCurrency,
                        remark: this.inputRemark,
                        status: 'A'
                    }
                }
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'countries', null, countryPayload)    
                if(post_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(post_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        update: async function(){
            if(!this.validateForm()) {
                var countryPayload = {
                    country: {
                            name: this.inputName.trim(), 
                            code: this.inputCode.trim(), 
                            currency_id: this.inputCurrency,
                            remark: this.inputRemark
                        }
                    }
                // status: 'A'
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'countries/' + this.profileId, null, countryPayload) 
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
    }
}
</script>

<style>
</style>
